import TaboolaIcon from "@/components/ui/OpticksIcons/TaboolaIcon";
import { routesMap } from "@/components/routes/routes";
import ChannelIntegrationGuide from "@/components/channel-integration-guide/ChannelIntegrationGuide";
import type { ChannelIntegrationConfig } from "@/components/channel-integration-guide/ChannelIntegrationGuide.types";
import TaboolaIntegrationStep1 from "./steps/components/TaboolaIntegrationStep1";
import TaboolaIntegrationStep2 from "./steps/components/TaboolaIntegrationStep2";

const taboolaConfig: ChannelIntegrationConfig = {
  channelName: "Taboola",
  channelDisplayName: "Taboola",
  platformKey: "taboola",
  oauthPlatformKey: "taboola",
  icon: <TaboolaIcon size={32} />,
  supportsOAuth: false,
  overviewPath: routesMap.integration.taboola.overview.path,
  linkingPath: routesMap.integration.taboola.linking.path,
  pixelManagementPath:
    routesMap.integration.channelsCenter.path + "?channel=taboola",
  guideSteps: [
    {
      content: (stepLabel) => <TaboolaIntegrationStep1 stepLabel={stepLabel} />,
    },
    {
      content: (stepLabel) => <TaboolaIntegrationStep2 stepLabel={stepLabel} />,
    },
  ],
};

const TaboolaIntegration = () => {
  return <ChannelIntegrationGuide config={taboolaConfig} />;
};

export default TaboolaIntegration;
